import React from 'react';
import { DataTable } from '@trackman/react-ui';
import styled from 'styled-components';
import { grey } from 'styles/Colors';
import { Button, Modal } from '@trackman/web-shared-components';

export const StyledModal = styled((props) => <Modal {...props} />)`` as typeof Modal;

export const MasterGameTable = styled((props) => <DataTable {...props} />)`
  border-radius: 5px;
  border: 1px solid ${grey};
  overflow: hidden;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const SlaveGameTable = styled((props) => <DataTable {...props} />)`
  margin-top: 10px;
  margin-bottom: 20px;
`;

export const Title = styled.span`
  display: block;
  text-align: left;
  text-transform: uppercase;
  font-family: Oswald;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  align-items: center;
  letter-spacing: 0.5px;
`;

export const Divider = styled.div`
  border-bottom: 1px solid #e0e0e0;
  height: 0px;
`;

export const TableDividerText = styled.span`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 21px;
  margin-top: 10px;
`;

export const MergeModalFooter = styled.div`
  margin-top: 20px;
  display: flex;
`;

export const Controls = styled.div`
  display: block;
  width: 100%;
`;

export const FooterNote = styled.span`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 21px;
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
`;

export const ModalContent = styled.div`
  padding: 24px;
`;
